import React, { Component } from "react";
import TimetableCard from "./Card";
import Header from "../../Components/MainLayout/Header";
import { connect } from "react-redux";
import axios from "axios";
import Authorize from "../../../global/Authorize";
import Skeleton from "react-loading-skeleton";
import noData from "../../Assets/img/noData.png";

const data = [
  { day: "Monday" },
  { day: "Tuesday" },
  { day: "Wednesday" },
  { day: "Thursday" },
  { day: "Friday" },
  { day: "Saturday" },
];

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class Timetable extends Component {
  state = {
    currentTab: 0,
    data: data,
    table: [],
    loading: true,
    fakeData: [1, 2, 3, 4],
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Time Table";
    this.fetch({
      session: this.props.user.session.id,
      sub_teacher: this.props.user.id,
    });
  }

  fetch = (params = {}) => {
    this.setState({ loading: true });
    axios
      .get(`mApiV1/TeacherTimeTable`, {
        params: { ...params },
      })
      .then((res) => {
        this.setState({
          table: res.data,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
  };
  render() {
    return (
      <Authorize roles={["IS_TEACHER"]} redirect to="/">
        <Header title="Time Table" />

        <div
          className="d-flex flex-row th-no-scroll pt-2"
          style={{ overflowX: "scroll" }}
        >
          {this.state.data?.map((item, index) => {
            return (
              <div
                key={index}
                className="px-4 text-center th-cap th-14 pt-2"
                onClick={() => this.setState({ currentTab: index })}
              >
                <div
                  className={
                    this.state.currentTab === index
                      ? "th-primary th-medium"
                      : "th-black"
                  }
                >
                  {item.day}
                </div>
                {this.state.currentTab === index ? (
                  <hr
                    className="w-100 my-1 th-border"
                    style={{ borderWidth: 5, borderRadius: 5 }}
                  />
                ) : null}
              </div>
            );
          })}
        </div>

        <div className="container">
          {this.state.loading
            ? this.state.fakeData?.map((item, index) => (
                <div className="border p-3 shadow-sm rounded-lg mb-3">
                  <Skeleton width={100} />
                  <Skeleton />
                </div>
              ))
            : null}

          {this.state.table.length !== 0 && this.state.loading === false
            ? this.state.table?.map((item, index) =>
                item.class_period[this.state.currentTab]
                  .subject__subject_code === "NAN" ? (
                  ""
                ) : (
                  <div className="pb-3">
                    <TimetableCard
                      data={item.class_period[this.state.currentTab]}
                      start={item.start_time}
                      end={item.end_time}
                    />
                  </div>
                )
              )
            : null}
          {this.state.table.length === 0 && this.state.loading === false ? (
            <div className="px-5 py-5">
              <img className="w-100 mt-5" src={noData} alt="No Data Found" />
              <p className="text-center th-14 th-bold mt-5">
                No Timetable to Show!
              </p>
            </div>
          ) : null}
        </div>
      </Authorize>
    );
  }
}
export default connect(mapStateToProps)(Timetable);
